import { PACKAGE } from 'resources/constants'

export const getPackageLabel = (packageType?: string, packageQty?: string) => {
  const isEach = packageType === PACKAGE.EACH

  if (isEach) {
    return 'Each'
  } else if (packageQty) {
    return `per bag / ${packageQty} pieces`
  } else {
    return `Pieces / ${packageType}`
  }
}

export function shade (color: string, percent: number) {
  var f=parseInt(color.slice(1), 16)
  var t=percent<0?0:255
  var p=percent<0?percent*-1:percent
  var R=f>>16
  var G=(f>>8)&0x00FF
  var B=f&0x0000FF
  return '#'+(0x1000000+(Math.round((t-R)*p)+R)*0x10000+(Math.round((t-G)*p)+G)*0x100+(Math.round((t-B)*p)+B)).toString(16).slice(1)
}
